//LOGIN
export const POST_LOGIN = "/auth/login";

//DEVICE
export const GET_FLOORPLAN = "/static/floorplan";
export const GET_MONITOR_TYPE = "/static/monitortype";
export const GET_MONITOR_STATUS = "/static/monitorstatus";
export const GET_CARE_REQUIREMENT = "/static/caretype";
export const GET_MONITOR_PERIOD = "/static/monitorperiod";
export const GET_APPLIED_RULES = "/static/appliedrules";
export const GET_REPORT_MONITOR_STATUS = "/static/monitorstatusforreport";
export const GET_EVENT_REPORT_REASON = "/static/eventreportreason";
export const GET_REPORT_EVENT_REPORT_REASON = "/static/eventreportreasonforreport";

//DEVICES
export const GET_ALL_DEVICE = "/monitor/all";
export const GET_ALL_DEVICE_CURRENT_STATUS = "/monitor/allcurrentstatus";
export const POST_PIN_DEVICE = "/monitor/pin";
export const HANDLE_EVENT_DEVICE = "/monitor/event/handle";
export const HANDLED_EVENT_DEVICE = "/monitor/event/handled";
export const CLOSE_EVENT_DEVICE = "/monitor/event/close";
export const LIST_STATUS_DEVICE = "/monitor/status/list";
export const POST_DEVICE_CONFIG = "/monitor/config";

//EVENT
export const GET_ALL_PENDING_EVENT = "/event/pending";
export const GET_EVENT = "/event";
export const REPORT_EVENT = "/event/report";
export const CREATE_EVENT_MESSAGE = "/event/message";
export const GET_EVENT_MESSAGE = "/event/message";
export const GET_EVENT_REPORT = "/event/report";
export const POST_EVENT_REPORT_SAVE = "/event/reportsave";
export const GET_EVENT_REPORT_LIST = "/event/reportlist";
export const DELETE_EVENT_REPORT = "/event/report";
export const GET_EVENT_REPORT_EXPORT = "/event/reportexport";

//SUMMARY
export const GET_SUMMARY_TOILET_FALL = "/monitor/summary/toiletfall";
export const GET_SUMMARY_TOILET_OT = "/monitor/summary/toiletot";
export const GET_SUMMARY_TOILET_ARRIVAL = "/monitor/summary/toiletarrival";
export const GET_SUMMARY_TOILET_USING_AVERAGE_TIME = "/monitor/summary/toiletusingaveragetime";
export const GET_SUMMARY_TOILET_USING_FREQUENCE = "/monitor/summary/toiletusingfrequence";
export const GET_SUMMARY_BED_FALL = "/monitor/summary/bedfall";
export const GET_SUMMARY_BED_ARRIVAL = "/monitor/summary/bedarrival";

//DEVELOPER
export const GET_DEVELOPER_DEVICES = "/developer/devices";
export const GET_DEVICE_CONFIG = "/developer/config";
export const GET_VERSION = "/api/version";
export const UPDATE_PASSWORD = "/developer/updatepassword";

//ADMIN
export const GET_ADMIN_COMPANY = "/admin/company";
export const UPDATE_ADMIN_COMPANY = "/admin/company";
export const CREATE_ADMIN_COMPANY = "/admin/company";

//ADMIN SIM
export const GET_ADMIN_COMPANY_SIM = "/admin/simcard";
export const CREATE_ADMIN_COMPANY_SIM = "/admin/simcard";
export const UPDATE_ADMIN_COMPANY_SIM = "/admin/simcard";

// ADMIN DEVICE
export const GET_ADMIN_COMPANY_DEVICE = "/admin/device";
export const CREATE_ADMIN_COMPANY_DEVICE = "/admin/device";
export const UPDATE_ADMIN_COMPANY_DEVICE = "/admin/device";

// ADMIN DEVICE RECORD
export const GET_ADMIN_COMPANY_DEVICE_UPDATE = "/admin/deviceupdate";
export const CREATE_ADMIN_COMPANY_DEVICE_UPDATE = "/admin/deviceupdate";

export const GET_ADMIN_COMPANY_DEVICE_UPDATE_PHOTO = "/admin/deviceupdate/photo";

export const GET_ADMIN_COMPANY_DEVICE_CONTRACT = "/admin/devicecontract";
export const CREATE_ADMIN_COMPANY_DEVICE_CONTRACT = "/admin/devicecontract";
export const UPDATE_ADMIN_COMPANY_DEVICE_CONTRACT = "/admin/devicecontract";


export const GET_ADMIN_COMPANY_DEVICE_ISSUE = "/admin/deviceissue";
export const GET_ADMIN_COMPANY_DEVICE_UPDATE_FOR_ISSUE = "/admin/deviceissue";
export const CREATE_ADMIN_COMPANY_DEVICE_ISSUE = "/admin/deviceissue";
export const PUT_ADMIN_COMPANY_DEVICE_ISSUE_STATUS = "/admin/deviceissue";

export const GET_DEVELOPER_ALL_COMPANY = "/internal/listcompany";
export const GET_DEVELOPER_FLOORPLAN_BY_COMPANY_ID = "/internal/companyfloorplan";
export const GET_DEVELOPER_EVENT_BY_COMPANY_ID = "/internal/companyevents";
export const GET_CONNECTION_LOG_BY_DEVICE_ID = "/internal/connectionlog";
export const GET_DEVICE_ID_BY_COMPANY_ID = "/internal/listdevicesbycompany";